import { Checkbox, Icon, useTranslation } from '@testsigma/atoms';

interface IOSKeychainSupportPanelProps {
  iosKeychainSupport: boolean;
  onChangeIosKeychainSupport: (value: boolean) => void;
}

export const IOSKeychainSupportPanel: React.FC<
  IOSKeychainSupportPanelProps
> = ({ iosKeychainSupport, onChangeIosKeychainSupport }) => {
  const { t } = useTranslation();
  return (
    <div className='flex items-center gap-x-2'>
      <Checkbox
        checked={iosKeychainSupport}
        onChange={onChangeIosKeychainSupport}
        size='small'
        type='primary'
        label={t('uploads.form.label.ios_keychain_support')}
      />
      <Icon
        name='info'
        toolTip={t('uploads.form.tooltip.ios_keychain_support')}
        className='text-base text-secondary-500 !block'
      />
    </div>
  );
};
